module.exports = __webpack_public_path__ + "img/icon_6.1b9fd272.png";